"use client";

/**
 * HeaderBreadcrumb — Wave 34 Claude Design breadcrumb pattern.
 * Auto-derives from usePathname() — supports 2-level deep.
 */
import * as React from "react";
import { usePathname } from "next/navigation";

const ROUTE_LABELS: Record<string, string> = {
  "dashboard": "Ana Pano",
  "inbox": "Aksiyon Kutusu",
  "ask": "Sor",
  "audit": "Audit",
  "scrape-health": "Scrape Health",
  "share-of-shelf": "Share of Shelf",
  "keywords": "Anahtar Kelime",
  "sponsored-sov": "Sponsorlu SoV",
  "slots": "Slot İzleyici",
  "buybox-tracker": "BuyBox Pay",
  "price-tracker": "Fiyat Takip",
  "promo-watch": "Promosyon",
  "campaign-pulse": "Kampanya Nabzı",
  "content-quality": "İçerik Kalitesi",
  "image-compliance": "Görsel Uyum",
  "copy-optimizer": "Copy Optimizer",
  "image-gaps": "Görsel Eksik",
  "voice-of-shopper": "Yorum Sesi",
  "velocity": "Satış Hızı",
  "competitor-scorecard": "Rakip Karne",
  "keyword-gaps": "Kw Boşlukları",
  "forecasting": "Tahmin",
  "assortment-gap": "Ürün Gap",
  "seller-map": "Seller Haritası",
  "distribution-coverage": "Dağıtım Pay",
  "investment-allocator": "Yatırım 2×2",
  "welcome": "Hoş Geldin",
};

const GROUP_MAP: Record<string, string> = {
  "share-of-shelf": "Görünürlük",
  "keywords": "Görünürlük",
  "sponsored-sov": "Görünürlük",
  "slots": "Görünürlük",
  "buybox-tracker": "Görünürlük",
  "price-tracker": "Fiyat & Promo",
  "promo-watch": "Fiyat & Promo",
  "campaign-pulse": "Fiyat & Promo",
  "content-quality": "İçerik",
  "image-compliance": "İçerik",
  "copy-optimizer": "İçerik",
  "image-gaps": "İçerik",
  "voice-of-shopper": "Rekabet & Tahmin",
  "velocity": "Rekabet & Tahmin",
  "competitor-scorecard": "Rekabet & Tahmin",
  "keyword-gaps": "Rekabet & Tahmin",
  "forecasting": "Rekabet & Tahmin",
  "assortment-gap": "Dağıtım",
  "seller-map": "Dağıtım",
  "distribution-coverage": "Dağıtım",
  "investment-allocator": "Eylem",
};

export function HeaderBreadcrumb(): React.JSX.Element {
  const pathname = usePathname() ?? "";
  const segments = pathname.split("/").filter(Boolean);
  const last = segments[segments.length - 1] ?? "dashboard";
  const label = ROUTE_LABELS[last] ?? last;
  const group = GROUP_MAP[last];
  return (
    <nav className="header-breadcrumb" aria-label="Breadcrumb">
      <span>Commerco</span>
      <span style={{ color: "var(--text-faint)" }}>›</span>
      {group && (
        <>
          <span>{group}</span>
          <span style={{ color: "var(--text-faint)" }}>›</span>
        </>
      )}
      <span className="crumb-active">{label}</span>
    </nav>
  );
}
